import {faPaperclip} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {boundMethod} from "autobind-decorator";
import React from "react";
import {IntlShape, injectIntl} from "react-intl";
import {Link} from "react-router-dom";

import {EDocIdPrefixes, IItemSelectionState, INestedBaseItem} from "./models";

import InlineCheckbox from "@toolbox/button-like/InlineCheckbox";
import Highlighter from "@toolbox/display-blocks/Highlighter";
import {displayWavelength} from "@toolbox/display-blocks/Wavelength";
import {parseNumber} from "@translate/T";
import {getSelection, isSelected} from "./SearchItem";
import {getDocIdInfo} from "./doc-type";

export interface ICentrifugeSamplesProps {
    intl: IntlShape;
    project: number;
    selection: IItemSelectionState;
    items: INestedBaseItem[] | undefined;
    query: string;

    onChange(selection: IItemSelectionState): void;
}

class CentrifugeSamples extends React.PureComponent<ICentrifugeSamplesProps> {
    @boundMethod
    public onSelected(checked: boolean, id: string) {
        const samples = this.getSamples();
        if (!samples) {
            return;
        }

        const changed = samples.find((x) => id.includes(x.id));
        if (!changed) {
            return;
        }

        changed.selected = checked;
        this.props.onChange(getSelection(samples));
    }

    public render() {
        const samples = this.getSamples();
        if (!samples) {
            return null;
        }

        const show = new Set(samples.map((x) => x.wavelength)).size > 1;
        return samples.map(
            ({hasAttachment, id, name, selected, url, wavelength}) => (
                <React.Fragment key={id}>
                    <InlineCheckbox
                        idSuffix={id}
                        className="mb-1"
                        checked={selected}
                        toggle={this.onSelected}
                    >
                        <Link to={url}>
                            {this.renderName(show, name, wavelength)}
                        </Link>
                        {hasAttachment && (
                            <FontAwesomeIcon
                                className="ml-2 text-muted"
                                icon={faPaperclip}
                            />
                        )}
                    </InlineCheckbox>
                    <br />
                </React.Fragment>
            ),
        );
    }

    private renderName(
        showWavelength: boolean,
        name: string,
        wavelength: number,
    ) {
        const {intl, query} = this.props;

        let displayName = name;
        if (showWavelength) {
            displayName += ` (${displayWavelength(intl, wavelength)})`;
        }

        return <Highlighter query={query} text={displayName} />;
    }

    private getSamples() {
        const {project, selection, items} = this.props;
        const centItems = items?.filter((x) =>
            x.id.startsWith(EDocIdPrefixes.CentSamples),
        );
        if (!centItems?.length) {
            return null;
        }

        return centItems.map((x) => {
            const {url, id} = getDocIdInfo(x.id, project);
            const [_, __, ___, ____, wavelength] = x.id.split("/");
            const {hasAttachment, name} = x;

            return {
                id,
                wavelength: parseNumber(wavelength),
                name,
                selected: isSelected(id, selection),
                url,
                hasAttachment,
            };
        });
    }
}

export default injectIntl(CentrifugeSamples);
